
    export default {
        name: 'LeeTransfer',
        inheritAttrs: false,
        data() {
            return {
                keyword1: '',
                keyword2: ''
            }
        },
        mounted() {
            this.list.map((el) => {
                this.$set(el, 'choose', false) //choose表示选中状态
                this.$set(el, 'flag', 0) //flag=0表示在左边，flag=1表示在右边
            })
            for (var i = 0; i < this.value.length; i++) {
                var value = this.value[i].toString()
                var fi = this.list.filter(function (el) {
                    return el.key.toString().indexOf(value) > -1;
                });
                this.$set(fi[0], 'flag', 1)
            }

        },
        computed: {
            leftdata() {
                var _this = this
                var fi = this.list.filter(function (el) {
                    return el.flag == 0;
                });
                if (this.filterable) {
                    var fii = fi.filter(function (el) {
                        return el.label.toLowerCase().indexOf(_this.keyword1.toLowerCase()) > -1;
                    });
                    return fii
                } else {
                    return fi
                }

            },
            rightdata() {
                var _this = this
                var fi = this.list.filter(function (el) {
                    return el.flag == 1;
                });
                if (this.filterable) {
                    var fii = fi.filter(function (el) {
                        return el.label.toLowerCase().indexOf(_this.keyword2.toLowerCase()) > -1;
                    });
                    return fii
                } else {
                    return fi
                }
            },
            lefttj() {
                return this.leftdata.length
            },
            leftxz() {
                var fi = this.leftdata.filter(function (el) {
                    return el.choose == true
                });
                return fi.length
            },
            righttj() {
                return this.rightdata.length
            },
            rightxz() {
                var fi = this.rightdata.filter(function (el) {
                    return el.choose == true
                });
                return fi.length
            },
            allleft() {
                if (this.leftdata.length < 1) {
                    return false
                }
                var fii = this.leftdata.every(function (el) {
                    return el.choose == true;
                })
                return fii
            },
            allright() {
                if (this.rightdata.length < 1) {
                    return false
                }
                var fii = this.rightdata.every(function (el) {
                    return el.choose == true;
                })
                return fii
            },
        },
        methods: {
            allleftchoose() {
                var jg = this.leftdata.some(function (el) {
                    return !el.choose;
                })
                if (jg) {
                    this.leftdata.map(function (el) {
                        el.choose = true
                    })
                } else {
                    this.leftdata.map(function (el) {
                        el.choose = false
                    })
                }
            },
            allrightchoose() {
                var jg = this.rightdata.some(function (el) {
                    return !el.choose;
                })
                if (jg) {
                    this.rightdata.map(function (el) {
                        el.choose = true
                    })
                } else {
                    this.rightdata.map(function (el) {
                        el.choose = false
                    })
                }
            },
            toleft() {
                var _this = this
                var fi = this.rightdata.filter(function (el) {
                    return el.choose == true
                });
                fi.map(function (el) {
                    _this.$set(el, 'flag', 0)
                    _this.$set(el, 'choose', false)
                })
                this.changeV()
            },
            toright() {
                var _this = this
                var fi = this.leftdata.filter(function (el) {
                    return el.choose == true
                });
                fi.map(function (el) {
                    _this.$set(el, 'flag', 1)
                    _this.$set(el, 'choose', false)
                })
                this.changeV()
            },
            changeV() {
                let ll = []
                let fii = this.list.filter((el) => {
                    return el.flag == 1
                })
                fii.map((el) => {
                    ll.push(el.key)
                })
                this.$emit('input', ll)
            }
        },
        props: {
            list: {
                type: Array,
                default() {
                    return []
                }
            },
            value: {
                type: Array,
                default() {
                    return []
                }
            },
            title1: {
                type: String,
                default: ''
            },
            title2: {
                type: String,
                default: ''
            },
            filterable: {
                type: Boolean,
                default: false
            }

        }
    };
